'use client'

import { useLessonViewModel } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import { match } from 'ts-pattern'

import { BadgeV1, HStack, Typography } from '@podo-app/design-system-temp'

export const TrialLessonCardHeader = () => {
  const { viewModel } = useLessonViewModel()
  const t = useTranslation()

  return (
    <HStack className="gap-2">
      <Typography size="h2" className="font-bold" asChild={false}>
        {t('lessonCard.trial.curriculum', { grade: viewModel.entity.classCourseGrade ?? '' })}
      </Typography>

      {match(viewModel.trialStatus)
        .with(viewModel.CLASS_STATUS_MAP.NOT_RESERVED, () => (
          <BadgeV1 variant={viewModel.statusColor}>{t('lesson.status.WAITING')}</BadgeV1>
        ))
        .with(viewModel.CLASS_STATUS_MAP.RESERVED, () => (
          <BadgeV1 variant={viewModel.statusColor}>{t('lesson.status.RESERVED')}</BadgeV1>
        ))
        .otherwise(() => (
          <BadgeV1 variant={viewModel.statusColor}>{t(`lesson.status.${viewModel.status}`)}</BadgeV1>
        ))}
    </HStack>
  )
}
